import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Home from "./pages/Home";
import About from "./pages/About";
import Portfolio from "./pages/Portfolio";
import Contact from "./pages/contact";
import Service from "./pages/Service";

import ContactForm from "./components/ContactForm";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  const [isFormOpen, setIsFormOpen] = useState(false);

  const openForm = () => setIsFormOpen(true);
  const closeForm = () => setIsFormOpen(false);

  return (
    <BrowserRouter>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<Home openForm={openForm} />} />
        <Route path="/about" element={<About openForm={openForm} />} />
        <Route path="/portfolio" element={<Portfolio openForm={openForm} />} />
        <Route path="/portfolio/admin" element={<Portfolio />} />
        <Route path="/service" element={<Service openForm={openForm} />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/form" element={<ContactForm />} />
      </Routes>

      {isFormOpen && (
        <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/60 p-3 sm:p-4">
          <div className="relative w-full max-w-[95%] sm:max-w-xl md:max-w-2xl lg:max-w-3xl max-h-[90vh] overflow-y-auto rounded-xl sm:rounded-2xl bg-white shadow-2xl">

            <button
              onClick={closeForm}
              className="absolute right-3 top-3 sm:right-5 sm:top-5 text-2xl sm:text-3xl font-bold text-gray-600 hover:text-black"
            >
              ×
            </button>

            <ContactForm />

          </div>
        </div>
      )}
    </BrowserRouter>
  );
}

export default App;

